<script>
export default {
  props: {
    menuToggle: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      navWidth: 280,
      menuStatus: false
    }
  },
  watch: {
    menuToggle: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.navWidth = 280
        this.menuStatus = newVal
      } else {
        this.navWidth = 0
        this.menuStatus = false;
        // this.calcNavWidth()
      }
      // // // console.log(newVal)
      // if (newVal === true) {
      //   this.navWidth = 280
      //   this.menuStatus = newVal
      // } else {
      //   this.navWidth = 0
      //   this.menuStatus = false;
      //   this.calcNavWidth()
      // }
    },
  },
  mounted() {
    if(window.innerWidth < 980)
      this.navWidth = 0;

    let that = this
    window.addEventListener('resize', function() {
      this.menuStatus = false;
      if(this.menuStatus){
        that.calcNavWidth()
      }else if(!this.menuStatus && window.innerWidth < 980){
        this.navWidth = 0
      }
      // // // console.log('resizing')
      // if(this.menuStatus){
      //   that.calcNavWidth()
      // } else if(window.innerWidth > 980){
      //   that.calcNavWidth()
      // }
    })
  },
  methods: {
    click() {
      return true
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    calcNavWidth() {
      if (window.innerWidth < 980) {
        this.navWidth = 0
      } else if (!this.menuStatus && window.innerWidth < 980){
        this.navWidth = 0
      } else if (window.innerWidth > 980){
        this.navWidth = 280
      }
    },
  },
}
</script>

<template>
  <VNavigationDrawer
    stateless
    dark
    value="true"
    :width="navWidth"
    :menu-props="{ absolute: true }"
    temporary
    hide-overlay
  >
    <img
      src="../../assets/images/power-logo.png"
      alt="power waste logo"
      :class="$style.navLogo"
    >
    <VList>
      <VListTile
        @click="changeRoute('/my-services')"
      >
        <VListTileTitle>
          <span :class="$style.navTitle">
            My Services
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/my-account')"
      >
        <VListTileTitle>
          <span :class="$style.navTitle">
            My Account
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/invoices')"
      >
        <VListTileTitle>
          <span :class="$style.navTitle">
            Invoices
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/reports')"
      >
        <VListTileTitle>
          <span :class="$style.navTitle">
            Reports
          </span>
        </VListTileTitle>
      </VListTile>

      <VListTile
        @click="changeRoute('/logout')"
      >
        <VListTileTitle>
          <span :class="$style.navTitle">
            Logout
          </span>
        </VListTileTitle>
      </VListTile>

    </VList>
  </VNavigationDrawer>
</template>

<style lang="scss" module>
@import '@design';

.navLogo {
  display: block;
  width: 50%;
  padding-top: 40px;
  padding-bottom: 40px;
  margin: 0 auto;
}

.navTitle {
  padding-left: 20px;
  // font-family: $poppins-medium;
  font-family: 'Poppins', sans-serif !important;
  font-size: 15px;
}

.navSubtitle {
  padding-left: 30px;
}
</style>
